module.exports = __webpack_public_path__ + "img/logo@2x.048a7a9b.png";